import React from "react";
import { roundToUnit } from "../../../classes/utils/NumbersUtils";
import "./Spp.css";

const SimpleSpp = ({ param }) => {
  const renderValue = (value, defaultValue = "-") => {
    return (
      <span className="Spp-measurement-value">
        {roundToUnit(value) ?? defaultValue}
      </span>
    );
  };

  // Get the display name and value
  const displayName = `${param.shortName} - ${param.name}`;
  const unit = param.unit || "";
  const value = param.originalValue || param.value;

  return (
    <div className="spp-parameter">
      <div className="Analyse-spp-option App-text-medium simple-spp">
        <span className="Spp-measurement-name simple-spp-name">
          {displayName} {unit && `[${unit}]`}
        </span>
        {renderValue(value, "-")}
      </div>
    </div>
  );
};

export default SimpleSpp;
